/* Private Room: deterministic scroll, no timers, no persistent animation loop.
   Shopify owns contact submission, validation and returned feedback. */
(() => {
  'use strict';
  const clamp=v=>Math.max(0,Math.min(1,v));
  const ramp=(p,a,b)=>{const t=clamp((p-a)/(b-a));return t*t*(3-2*t);};
  const hold=(p,a,b,c,d)=>ramp(p,a,b)*(1-ramp(p,c,d));
  function state(p,width){
    const open=ramp(p,.76,1.10)*(1-ramp(p,2.08,2.43));
    return {open,door:1-ramp(p,.76,.94),message:hold(p,1.12,1.28,1.95,2.07),invitation:ramp(p,2.45,2.72),
      sealX:-width*.28*ramp(p,.05,.32),split:52*ramp(p,.68,.98),lineScale:ramp(p,.60,.76),lineAlpha:hold(p,.60,.66,.80,.94),
      context:1-ramp(p,.45,.57),standardAlpha:1-ramp(p,.46,.58),
      standard:[ramp(p,.05,.16),ramp(p,.18,.29),ramp(p,.31,.43)]};
  }
  window.DylumaPrivateRoom={state};
  let dispose;
  const focusFeedback=(root=document)=>{const el=root.querySelector('[data-dp-feedback]');if(el)el.focus();};
  function initialize(){
    dispose?.();
    const page=document.querySelector('[data-professional-experience]');if(!page)return;
    const story=page.querySelector('[data-room-story]'),stage=page.querySelector('.room-stage');if(!story||!stage)return;
    const media=window.matchMedia('(prefers-reduced-motion: reduce)'),controller=new AbortController(),options={signal:controller.signal};
    const panels=[...stage.querySelectorAll('[data-room-panel]')];
    let frame=0,active=false;
    const set=(key,val)=>stage.style.setProperty('--room-'+key,val);
    function update(){
      frame=0;if(!active||document.hidden)return;
      const rect=story.getBoundingClientRect(),height=stage.getBoundingClientRect().height||window.innerHeight;
      const p=clamp(-rect.top/Math.max(1,story.offsetHeight-height))*3;
      const s=state(p,window.innerWidth);
      set('inset',(50*(1-s.open))+'%');set('ink',s.open>.5?'#061425':'#cbb48c');
      for(const key of ['door','message','invitation'])set(key,s[key]);
      set('seal-x',s.sealX+'px');set('half-left',-s.split+'px');set('half-right',s.split+'px');set('line-scale',s.lineScale);set('line-alpha',s.lineAlpha);
      s.standard.forEach((v,i)=>set('standard-'+(i+1),v));
      set('context',s.context);set('standard-alpha',s.standardAlpha);
      panels.forEach(el=>{const visible=s[el.dataset.roomPanel]>.1;el.inert=!visible;el.setAttribute('aria-hidden',String(!visible));});
    }
    function schedule(){if(!frame)frame=requestAnimationFrame(update);}
    function configure(){
      active=!media.matches&&!navigator.connection?.saveData&&window.innerHeight>=420;
      page.classList.toggle('room-active',active);
      if(!active){panels.forEach(el=>{el.inert=false;el.removeAttribute('aria-hidden');});}
      schedule();
    }
    window.addEventListener('scroll',schedule,{...options,passive:true});
    window.addEventListener('resize',configure,options);
    window.visualViewport?.addEventListener('resize',schedule,options);
    window.addEventListener('pageshow',schedule,options);document.addEventListener('visibilitychange',schedule,options);
    media.addEventListener('change',configure,options);
    page.querySelectorAll('.room-link').forEach(link=>link.addEventListener('click',()=>page.querySelector('#richiesta-professional')?.focus({preventScroll:true}),options));
    configure();
    dispose=()=>{controller.abort();if(frame)cancelAnimationFrame(frame);page.classList.remove('room-active');panels.forEach(el=>{el.inert=false;el.removeAttribute('aria-hidden');});};
  }
  initialize();focusFeedback();
  document.addEventListener('shopify:section:load',event=>{initialize();focusFeedback(event.target);});
  document.addEventListener('shopify:section:unload',()=>{if(!document.querySelector('[data-professional-experience]'))dispose?.();});
})();
